export default __webpack_public_path__ + "static/media/turn_left_90deg.654a0ce6.mp3";